
  var _styles = {
  "amount-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "baseline",
    "width": "100%",
    "height": "1.12rem"
  },
  "currency": {
    "position": "relative",
    "fontSize": "0.42667rem",
    "lineHeight": "0.58667rem",
    "color": "rgb(255,59,48)",
    "fontWeight": "600"
  },
  "currency-point": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "textAlign": "left"
  },
  "amount": {
    "fontSize": "0.8rem",
    "color": "rgb(255,59,48)",
    "fontWeight": "700",
    "lineHeight": "1.2rem",
    "position": "relative"
  }
};



  module.exports = _styles;
  